import React from 'react';

import CatalogShell from './CatalogShell';

const TaskCategories: React.FC = () => (
  <CatalogShell
    slug="task-categories"
    title="Task categories"
    breadcrumbLabel="Task categories"
    emptyBody="Task categories group related tasks on the consumer app. Tasks can't be created until at least one exists."
    addCtaLabel="Add first task category"
  />
);

export default TaskCategories;
